import bindAll from 'lodash.bindall';
import React, {Fragment} from 'react';
import classNames from 'classnames';
import lottie from 'lottie-web';

import styles from './baize-lottie.module.css';
import { sessionStore } from '../../lib/xes/local-store.js';
import { loadAudioFile } from '../../lib/xes/buffer-player';
import answerRightData from '../../lib/xes/baize/answerRight.json';
import answerErrorData from '../../lib/xes/baize/answerError.json';
class BaizeLottie extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
          'getBoxWrapperRectInfo'
        ]);
        this.lottie = null
        this.state = {
          showTopTips: false,
          showBottomTips: false,
          topTipsStyle: {},
          bottomTipsStyle: {}
        };
    }
    componentDidMount () {
      var that = this
      that.setLottie() //dom已经就位
      // this.lottie.addEventListener('DOMLoaded', () => {
      that.lottie.addEventListener('enterFrame', event => {
        const time = Number(event.currentTime).toFixed(0)
        if (time >= 40 && time <= 80 && !that.isShowTipsMessage) {
          that.getBoxWrapperRectInfo()
          setTimeout(() => {
            window.dbgstore.dispatch({type:'baize/CLOSE_MODAL',modal:'baizeLottie'})
            this.lottie.stop()
            const answer_url = sessionStore.get('answer_url')
            window.location.href = answer_url
          }, 3000)
        }
      })
      // })
      that.lottie.play()
      window.addEventListener('resize', this.getBoxWrapperRectInfo)
    }
    componentDidUpdate (prevProps, prevState) {}
    componentWillUnmount () {
      window.removeEventListener('resize', this.getBoxWrapperRectInfo)
    }
    setLottie () {
      const lottieContainer = document.getElementById('baize-lottie')
      if(window.baizeAnswerIsRight){
        this.lottie = lottie.loadAnimation({
          container: document.getElementById('baize-lottie'),
          animationData: answerRightData,
          renderer: 'svg',
          loop: false,
          autoplay: false,
        })
        loadAudioFile('//livefile.xesimg.com/programme/python_assets/7c63c680612fbd5af27feff2cc4b65af.mp3')
      } else {
        this.lottie = lottie.loadAnimation({
          container: lottieContainer,
          animationData: answerErrorData,
          renderer: 'svg',
          loop: false,
          autoplay: false,
        })
        loadAudioFile('//livefile.xesimg.com/programme/python_assets/f17363a4c80779a5ff8c9c95fb50b66e.mp3')
      }
    }
    getBoxWrapperRectInfo() {
      const answerImgWrapper = document.getElementById('answer-right-box-wrapper-img')
      if (answerImgWrapper) {
        const posInfo = answerImgWrapper.getBoundingClientRect()
        // console.log('posInfo', posInfo)
        var topTipsStyle = Object.assign(this.state.topTipsStyle, {
          width: `${posInfo.width / 1.4}px`,
          height: `${posInfo.width / 3.1}px`,
          position: 'absolute',
          top: `${posInfo.top - 40 - posInfo.width / 3.1 / 3.5}px`
        })
        var bottomTipsStyle = Object.assign(this.state.bottomTipsStyle,{
          width: `${posInfo.width}px`,
          height: `${posInfo.height / 7}px`,
          position: 'absolute',
          top: `${posInfo.top + posInfo.height + 20}px`
        })
        this.setState({showTopTips: true, showBottomTips: true, topTipsStyle, bottomTipsStyle})
      }
    }
    render () {
      const {count, rewards, type} = this.props.rightcount // count 连对数
      let amounts = 0
      let message = ''
      let goldState

      const rewardsTemp = (rewards && rewards.length > 0) ? rewards[0] : null
      if(rewardsTemp) {
         goldState = rewardsTemp.state // 1获取成功 2已经获取过了 -1奖励被限制
         amounts = rewardsTemp.amounts
         if(goldState === 2) {
           message = '这道题已经领过金币了喔'
         } else if(goldState === -1) {
           message = '本关卡达到金币领取上限了喔'
         } else if(goldState === 1) {
           message = '首次答对奖励'
         } else {
           //TODO 其他状态情况
         }
      }
      return (
        <div className={styles.mask}>
          <div {...this.props} ></div>
          <div className={styles.answerRightMessageWarpper}>
            {this.state.showTopTips? <div className={classNames(styles.topTipsClass, styles[`topTipsMessage${count}`], {[styles.topTipsMessageDestination]: type === 'destination'}, styles.confirmModalFade)} style={{...this.state.topTipsStyle}} ></div>: null}
              {this.state.showBottomTips? <div className={classNames(styles.bottomTipsClass, styles.confirmModalFade)} style={{...this.state.bottomTipsStyle}}>
                {message}
                {(goldState == 1 && amounts > 0)? 
                <Fragment>
                  <img className={styles.coinsImg} src={require("./baize-img/answer-right-coin.png")} />
                  <span className={styles.coinsCount}>+{amounts}</span>
                </Fragment>: null}
              </div>: null}
          </div>
        </div>
      )
    }
}

export default BaizeLottie;
